import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { homeApiV2 } from '../../../lib/api/home/homeApiV2';
import { HomeTabCreateErrorCode, HomeTabCreateRequest } from '../../../types/home/tab';
import { CustomAxiosError } from '../../../types/common/http';
import { HomeTabsCreateRequestBodyDto, HomeTabsCreateResponseBodyDto } from '../../../types/api/home-tabs';

const tabCreatePayloadConverter = {
  clientToServer: (payload: HomeTabCreateRequest): HomeTabsCreateRequestBodyDto => ({
    title: payload.title,
    linkId: payload.link.id,
    linkUrl: payload.linkUrl || null,
    linkType: payload.linkType,
    memo: payload.memo,
    startDate: payload.period.startDate && new Date(payload.period.startDate).toISOString(),
    endDate: payload.period.endDate && new Date(payload.period.endDate).toISOString(),
  }),
};
export const useCreateHomeTabMutate = (
  mutateOptions: UseMutationOptions<
    HomeTabsCreateResponseBodyDto,
    CustomAxiosError<HomeTabCreateErrorCode>,
    HomeTabCreateRequest
  >,
) =>
  useMutation((payload) => homeApiV2.createHomeTab(tabCreatePayloadConverter.clientToServer(payload)), mutateOptions);
